import {createSlice} from '@reduxjs/toolkit';
import * as reducers from './reducers';
import * as selectors from './selectors';
import type {Store} from './types';

const initialState: Store = {
  layout: 1,
  upload: null,
  uploadItems: {},
  uploadView: {files: [], folders: []},
  downloadView: {files: [], folders: []},
  downloadItems: {},
  downloadBulk: [],
  uploadMinimized: false,
  downloadMinimized: false,
};

export default createSlice({name: 'transfers', reducers, initialState});
export {selectors};
